import _extends from "@babel/runtime/helpers/extends";
import { forwardRef, useCallback } from "react";
import { useBanner, bannerFooterInlineStyle, bannerFooterInlineStyleContainer, FooterLink, useCommonFooterLinks } from "../../.."; // eslint-disable-next-line react/display-name

var BannerFooter = /*#__PURE__*/forwardRef(function (_, ref) {
  var banner = useBanner();
  var isTcf = banner.isTcf,
      type = banner.layout.type,
      individualPrivacyOpen = banner.individualPrivacyOpen,
      updateIndividualPrivacyOpen = banner.updateIndividualPrivacyOpen,
      onClose = banner.onClose,
      tcf = banner.i18n.tcf,
      isConsentRecord = banner.isConsentRecord;
  var handleTcfVendorList = process.env.IS_TCF === "1" && isTcf ? useCallback(function (e) {
    updateIndividualPrivacyOpen(true);
    e.preventDefault();
  }, [updateIndividualPrivacyOpen]) : undefined;
  var handleClose = useCallback(function (e) {
    onClose();
    e.preventDefault();
  }, [onClose]);

  var _useCommonFooterLinks = useCommonFooterLinks({
    onClose: isConsentRecord ? handleClose : undefined,
    putPoweredByLinkInRow: type === "banner" ? 0 : 1,
    row1: [process.env.IS_TCF === "1" && isTcf && !individualPrivacyOpen && h(FooterLink, {
      href: "#",
      onClick: handleTcfVendorList,
      key: "vendorList"
    }, tcf.vendorList)]
  }),
      links = _useCommonFooterLinks.rows,
      renderLinks = _useCommonFooterLinks.render;

  return h("div", _extends({
    ref: ref
  }, bannerFooterInlineStyleContainer(banner)), h("div", bannerFooterInlineStyle(banner), renderLinks(links)));
});
export { BannerFooter };